import { coreInitiativesBulkDeleteAsyncSlice } from './delete';
import { coreInitiativesBulkPatchAsyncSlice } from './patch';

export const { requestDeleteCoreInitiativesBulk, resetDeleteCoreInitiativesBulk } =
	coreInitiativesBulkDeleteAsyncSlice.asyncActionCreators;

export const { requestPatchCoreInitiativesBulk, resetPatchCoreInitiativesBulk } =
	coreInitiativesBulkPatchAsyncSlice.asyncActionCreators;
